import type { Wallpaper } from '../firebase/schema'
import { DeviceType, DEVICE_DISPLAY_NAMES } from '../constants/device'
import { isWallpaperLabeledForDevice } from '../services/previewImageSelector'

export type DeviceWallpaperTab = DeviceType.MOBILE_PHONE | DeviceType.TABLET | DeviceType.LAPTOP | DeviceType.DESKTOP | DeviceType.ULTRAWIDE

export interface DeviceTabOption {
  device: DeviceWallpaperTab
  label: string
  shortLabel: string
  emoji: string
  count: number
}

export const DEVICE_WALLPAPER_TABS: DeviceWallpaperTab[] = [
  DeviceType.MOBILE_PHONE,
  DeviceType.TABLET,
  DeviceType.LAPTOP,
  DeviceType.DESKTOP,
  DeviceType.ULTRAWIDE
]

export const DEVICE_TAB_EMOJIS: Record<DeviceWallpaperTab, string> = {
  [DeviceType.MOBILE_PHONE]: '📱',
  [DeviceType.TABLET]: '📲',
  [DeviceType.LAPTOP]: '💻',
  [DeviceType.DESKTOP]: '🖥️',
  [DeviceType.ULTRAWIDE]: '🖥️'
}

export const DEVICE_TAB_SHORT_LABELS: Record<DeviceWallpaperTab, string> = {
  [DeviceType.MOBILE_PHONE]: 'Mobile',
  [DeviceType.TABLET]: 'Tablet',
  [DeviceType.LAPTOP]: 'Laptop',
  [DeviceType.DESKTOP]: 'Desktop',
  [DeviceType.ULTRAWIDE]: 'Ultrawide'
}

export const getDeviceWallpaperTabs = (wallpapers: Wallpaper[]): DeviceTabOption[] => {
  return DEVICE_WALLPAPER_TABS.map(device => {
    const count = wallpapers.filter(wallpaper => isWallpaperLabeledForDevice(wallpaper, device)).length
    return {
      device,
      label: DEVICE_DISPLAY_NAMES[device],
      shortLabel: DEVICE_TAB_SHORT_LABELS[device],
      emoji: DEVICE_TAB_EMOJIS[device],
      count
    }
  })
}

export const filterWallpapersForDevice = (wallpapers: Wallpaper[], device: DeviceWallpaperTab): Wallpaper[] => {
  return wallpapers.filter(wallpaper => isWallpaperLabeledForDevice(wallpaper, device))
}

export const getFirstAvailableDeviceTab = (wallpapers: Wallpaper[]): DeviceWallpaperTab => {
  const tabs = getDeviceWallpaperTabs(wallpapers)
  return tabs.find(tab => tab.count > 0)?.device || DEVICE_WALLPAPER_TABS[0]
}

export const getDeviceAspectRatio = (device: DeviceWallpaperTab): string => {
  switch (device) {
    case DeviceType.MOBILE_PHONE:
      return '9 / 16'
    case DeviceType.TABLET:
      return '4 / 3'
    case DeviceType.LAPTOP:
      return '16 / 10'
    case DeviceType.DESKTOP:
      return '16 / 9'
    case DeviceType.ULTRAWIDE:
      return '21 / 9'
    default:
      return '16 / 9'
  }
}

export const getDeviceDisplayLabel = (device: DeviceWallpaperTab): string => {
  return DEVICE_DISPLAY_NAMES[device]
}
